import request from "@/utils/stone_request";

export function check_push(params) {
  return request.post('check_push_stone', params, {login:false})
}
export function login(data) {
  return request.post("/login", data, { login: false });
}
/*
 * 用户信息
 * */
export function getUserInfo() {
  return request.get("/userinfo");
}